import React from 'react';
import { ChartTooltipContainer } from '../../LineChart/ChartTooltipContainer';
import { BarChartData } from '../BarChart.controller';
import classes from './BarChartTooltip.module.scss';
import { format } from 'date-fns';
import classNames from 'classnames';

type ChartBars = {
  dataKey?: string | number;
  name?: string | number;
  value?: (string | number)[] | string | number;
  payload?: {
    name: string;
    payload: BarChartData;
    date: Date;
    index: number;
    rangeStart: Date;
    rangeEnd: Date;
  } & { [key: string]: BarChartData };
}[];
type BarChartTooltipProps = {
  active?: boolean;
  payload?: ChartBars;
  displayMonthly: boolean | undefined;
  isWeekly: boolean | undefined;
  activeMetrics: string[];
  chartData: BarChartData[];
};
export const BarChartTooltipView = (props: BarChartTooltipProps) => {
  const { active, payload, displayMonthly, isWeekly, activeMetrics } = props;
  if (active && payload && payload.length) {
    const totalEngagement = payload.reduce(
      (acc, data) => (typeof data?.value === 'number' ? acc + data.value : acc),
      0
    );
    const date = payload[0].payload?.date ?? new Date();
    const reversedMetrics = activeMetrics.map(metric => metric).reverse();
    const copyPayload = [...payload].reverse();
    const weeklyFormat = 'EEE, MMM d, yyyy';
    const dateFormatMonth = 'MMM, yyyy';
    let tooltipTitle = displayMonthly ? format(date, dateFormatMonth) : format(date, weeklyFormat);
    if (isWeekly) {
      const firstDate = payload[0].payload?.rangeStart ?? new Date();
      const endDate = payload[0].payload?.rangeEnd ?? new Date();
      tooltipTitle = `${format(firstDate, weeklyFormat)} - ${format(endDate, weeklyFormat)}`;
    }
    return (
      <ChartTooltipContainer>
        <h5>{tooltipTitle}</h5>
        {reversedMetrics.map((metric, index) => {
          return (
            <div key={metric} className={classes.MetricRow}>
              <div className={classes.MetricContainer}>
                <div className={classNames(classes.Icon, classes[`Icon${metric}`])}></div>
                <div className={classes[`Metrics${metric}`]}>{metric}</div>
              </div>
              <div className={classes.ValueContainer}>
                {copyPayload[index]?.value?.toLocaleString('en-US') ?? 'No Data'}
              </div>
            </div>
          );
        })}
        {reversedMetrics.length > 1 && (
          <div className={classes.TotalEngagement}>
            <span>Total Engagement</span> <span>{totalEngagement.toLocaleString('en-US')}</span>
          </div>
        )}
      </ChartTooltipContainer>
    );
  }

  return null;
};
